import angular from 'angular';
import expenseReviewDetailsComponent from './expense-review-details.component';

let expenseReviewDetailsModule = angular.module('expenseReviewDetails', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider.state('expense-review-details', {
    parent: 'app',
    url: '/expenses/review/travel/:expenseReportId',
    template: '<expense-review-details></expense-review-details>',
    data: {
      pageHeader: true,
      pageTitle: 'Review Expense Report',
      pageDesc: 'Review Expense Report',
      breadcrumbLink: 'admin.expenses',
      breadcrumbText: 'View All Expense Reports'
    }
  })

})

.component('expenseReviewDetails', expenseReviewDetailsComponent);

export default expenseReviewDetailsModule;



// WEBPACK FOOTER //
// ./client/pages/admin/expense-review-details/expense-review-details.js